import { useMemo } from 'react';
import { useTrack } from '@hotjar/webapp/hooks/useTrack';

interface PermissionRequiredTracking {
  trackClick: (element: string) => void;
}

export const usePermissionRequiredTracking = (): PermissionRequiredTracking => {
  const track = useTrack();

  return useMemo(() => {
    return {
      trackClick: (element) => track.click(element, 'Permission Required Page', {}),
    };
  }, [track]);
};
